import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { ComponentBase } from "src/app/base/component-base";
import { EditWorkExperienceComponent } from "src/app/post-graduate-examination/work-experience-histroy/edit-work-experience/edit-work-experience.component";
import { ApplicantService } from "src/app/service/applicant.service";
import { BehaviorModelChangeService } from "src/app/service/behavior-model-change.service.service";
import { CookiesLocalService } from "src/app/service/cookies-local.service";
import { UtilService } from "src/app/service/util.service";
import * as uuid from "uuid";
@Component({
  selector: "app-add-edit-document",
  templateUrl: "./add-edit-document.component.html",
  styleUrls: ["./add-edit-document.component.css"],
})
export class AddEditDocumentComponent extends ComponentBase implements OnInit {
  title: string;
  types: { ValueId: string; DisplayValue: string }[];
  documentForm: FormGroup;
  documentFormData: FormData;
  fileName: any;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<EditWorkExperienceComponent>,
    private utilService: UtilService,
    cookieLocal: CookiesLocalService,
    applicantService: ApplicantService,
    behaviorModelChangeService: BehaviorModelChangeService,
    private fb: FormBuilder
  ) {
    super(applicantService, cookieLocal, behaviorModelChangeService);
  }

  ngOnInit() {
    this.fileName = uuid.v4();
    if (this.data.isNew) {
      this.data = {
        ApplicationDocumentId: 0,
        Name: "",
        ApplicationDocumentTypeId: 1,
        Description: "",
        FilePath: "",
        ApplicationId: this.applicantData.ApplicationId,
      };
    } else {
      this.data.FilePath = "";
    }
    this.title = this.data.isNew ? "Add New Document" : "Edit Document";
    this.documentForm = this.fb.group({
      ApplicationDocumentId: [
        this.data.ApplicationDocumentId,
        Validators.required,
      ],
      Name: [this.data.Name, Validators.required],
      ApplicationDocumentTypeId: [
        this.data.ApplicationDocumentTypeId,
        Validators.required,
      ],
      ApplicationId: [this.applicantData.ApplicationId, Validators.required],
      Description: [this.data.Description],
      FilePath: ["", Validators.required],
    });
    this.utilService.getApplicationDocumentTypes().subscribe((data) => {
      this.types = data.map((item) => ({
        ValueId: item.ValueId,
        DisplayValue: item.DisplayValue.toUpperCase(),
      }));
    });
  }
  onSelectFile(event: any) {
    const files = event.target.files;
    const file = files[0];

    if (files && file) {
      const reader = new FileReader();
      reader.readAsDataURL(file); // read file as data url

      reader.onload = (e) => {
        // called once readAsDataURL is completed
        const docUrl = reader.result;

        const fileName = this.fileName + "." + file.name.split(".")[1];
        this.documentFormData = new FormData();
        this.documentFormData.append("file", file, fileName);
        this.documentFormData.append(
          "folderPath",
          "/Content/ApplicantDocument/" + this.applicantData.StudentNumber + "/"
        );
      };
    }
  }
  onUpload() {
    console.log(this.documentForm.value);
    if (this.documentFormData) {
      this.documentFormData.append(
        "values",
        JSON.stringify(this.documentForm.value)
      );
      this.applicantService.UploadDocument(this.documentFormData).subscribe(
        (data) => {
          console.log(data);
        },
        (error) => {
          console.log(error);
        }
      );
    }
  }
}
